import React from 'react';
import Plot from 'react-plotly.js';
import raw_data from './A.json';
import PlaySlider from './PlaySlider.js';
import {Row, Col, Tabs} from 'antd'
import Correlation from './Correlation.jsx';
import Selection from './Selection.js';
import Selection2 from './Selection2.js';
import ScatterPlot from './ScatterPlot';
import {list_choice,list_code,list_country } from './constantData'
import CorrMap from './CorrMap.js'
// import TabPane from "reactstrap/es/TabPane";

const layout ={width: 900, height: 350,
    margin:{
        l:0,
        r:0,
        b:0,
        t:0,
        pad:0,
    },
    geo:{
        showframe: false,
        showcoastlines: false,
        projection:{
            type: 'scattermapbox'
        },
    }
};
const TabPane = Tabs.TabPane;

export default class CountryMap extends React.Component{
    constructor(props) {
        super(props);
        this.state = { data: [], layout: layout, frames: [], config: {},year:2000,version:1,
            selectedCountry:'United States',selectedData:'totalRate', scatterPlot: '', gdpScatterPlot: '',
            ageGroupPlot:'',genderPlot:'',map: '', gdpMap: '',GDPcorrelation: '',Popcorrelation:'',
            GDPageCorr:"", PopAgeCorr:"", selectedData1: 'GDP', PieChart: ""};
    }

    yoo=(data)=>{
        this.setState({selectedCountry:data.points[0].text})
        this.updateScatterPlot(this.state.selectedData, data.points[0].text)
        this.updateGdpScatterPlot()
        this.updataGenderPlot()
        this.updataAgeGroupPlot()
    }

    componentDidMount(){
        this.setState({layout})
        this.update(this.state.selectedData)
        this.updateData(this.state.selectedData)
        this.updateGdpScatterPlot(this.state.selectedCountry)
        this.updateGdpMap(this.state.year)
        this.updataGDPCorrelation()
        this.updataPopCorrelation()
        this.updataGDPAgeCorrelation()
        this.updataPopAgeCorrelation()
        this.updataGenderPlot()
        this.updataAgeGroupPlot()
        this.updatePieChart()
    };

    update(selectedData=this.state.selectedData){
        //selected data
        var tmp_lo=[];
        var tmp_z= [];
        var tmp_text =[];
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if (raw_data[i]['year'] === this.state.year){
                tmp_lo.push(raw_data[i]['code'])
                tmp_z.push(raw_data[i][selectedData])
                tmp_text.push(raw_data[i]['country'])
            }
        }
        //inserting Nan country
        let length = list_code.length;
        for (var i = 0;i<length;i++ ){
            if (tmp_lo.indexOf(list_code[i]) === -1){
                tmp_lo.push(list_code[i])
                tmp_z.push(NaN)
                tmp_text.push(list_country[list_code[i]])
            }
        }

        //get the max of the y
        let max_a =0
        arrayLength = tmp_z.length;
        for(let i = 0; i<arrayLength;++i){
            if (tmp_z[i]>max_a){
                max_a=tmp_z[i]
            }
        }

        //format of data
        clean_data = [{
            type: 'choropleth',
            locations: tmp_lo,
            z:tmp_z,
            text:tmp_text,
            zmin: 0,
            zmax: max_a,
            colorscale: [
                [0, 'rgb(255, 255, 255)'], [0.2, 'rgb(255, 230, 230)'],
                [0.4, 'rgb(255, 179, 179)'], [0.6, 'rgb(255, 128, 128)'],
                [0.8, 'rgb(255, 77, 77)'], [1, 'rgb(204, 0, 0)']
            ],
            colorbar: {
                title: selectedData + '\n(Per 100K Population)',
                thickness: 5,
                len:0.5,
                // xpad: 100,
            },
            marker: {
                line:{
                    color: 'rgb(183,183,183)',
                    width: 2
                }
            },
        }]
        this.setState({data:clean_data})
        let map = <Plot
            data={clean_data}
            layout={this.state.layout}
            onClick={this.yoo}
            revision={this.state.version}
            config={{displayModeBar:false}}
        />
        this.setState({map});
    }

    updateGdpMap=(year, selectedData=this.state.selectedData1)=>{
        //selected data
        var tmp_lo=[];
        var tmp_z= [];
        var tmp_text =[];
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if (raw_data[i]['year'] === year){
                tmp_lo.push(raw_data[i]['code'])
                tmp_z.push(raw_data[i][selectedData])
                tmp_text.push(raw_data[i]['country'])
            }
        }
        //inserting Nan country
        let length = list_code.length;
        for (var i = 0;i<length;i++ ){
            if (tmp_lo.indexOf(list_code[i]) === -1){
                tmp_lo.push(list_code[i])
                tmp_z.push(NaN)
                tmp_text.push(list_country[list_code[i]])
            }
        }

        //get the max of the y
        let max_a =0
        arrayLength = tmp_z.length;
        for(let i = 0; i<arrayLength;++i){
            if (tmp_z[i]>max_a){
                max_a=tmp_z[i]
            }
        }

        var titleName = '';
        if (selectedData === 'GDP'){
            titleName = '(US Dollar ($))';
        }
        //format of data
        clean_data = [{
            type: 'choropleth',
            locations: tmp_lo,
            z:tmp_z,
            text:tmp_text,
            zmin: 0,
            zmax: max_a,
            // colorscale: [
            //     [0, 'rgb(242,240,247)'], [0.2, 'rgb(218,218,235)'],
            //     [0.4, 'rgb(188,189,220)'], [0.6, 'rgb(158,154,200)'],
            //     [0.8, 'rgb(117,107,177)'], [1, 'rgb(84,39,143)']
            // ],
            colorscale: [
                [0, 'rgb(255, 255, 255)'], [0.2, 'rgb(255, 230, 230)'],
                [0.4, 'rgb(255, 179, 179)'], [0.6, 'rgb(255, 128, 128)'],
                [0.8, 'rgb(255, 77, 77)'], [1, 'rgb(204, 0, 0)']
            ],
            colorbar: {
                title: selectedData+titleName,
                thickness: 5,
                len:0.5,
                // xpad: 100,
            },
            marker: {
                line:{
                    color: 'rgb(183,183,183)',
                    width: 2
                }
            },
        }]
        this.setState({data:clean_data})
        let gdpMap = <Plot
            data={clean_data}
            layout={this.state.layout}
            onClick={this.yoo}
            revision={this.state.version}
            config={{displayModeBar:false}}
        />
        this.setState({gdpMap});
    }

    updateYear=(year)=>{
        this.setState({year})
        // this.updateData(this.state.selectedData)
        this.update()
        this.updateGdpMap(year)
        this.updataGDPCorrelation(year)
        this.updataPopCorrelation(year)
        this.updataPopAgeCorrelation(year)
        this.updataGDPAgeCorrelation(year)
        this.updatePieChart(year)
    }
    updateData=(selectedData)=>{
        this.setState({selectedData})
        this.update(selectedData)
        this.updateScatterPlot(selectedData)
    }
    updataGDPCorrelation(year=this.state.year){
        console.log(year)
        var xx=[]
        let yy = []
        let yy1 =[]
        let yy2 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['year'] === year){
                xx.push(raw_data[i]['GDP'])
                yy.push(raw_data[i]['totalRate'])
                yy1.push(raw_data[i]['maleRate'])
                yy2.push(raw_data[i]['femaleRate'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy,
                type: 'scatter',
                mode: 'markers',
                name: 'Total Rate',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Male Rate',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Female Rate',
                marker: {color: 'red'},
            },
        ]
        // this.setState({data:clean_data})
        let GDPcorrelation = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'GDP VS Male and Female Suicide Rate',
                xaxis: {title:{text: 'GDP'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({GDPcorrelation});
    }

    updataPopCorrelation(year=this.state.year){
        console.log(year)
        var xx=[]
        let yy =[]
        let yy1 =[]
        let yy2 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['year'] === year){
                xx.push(raw_data[i]['population'])
                yy.push(raw_data[i]['totalRate'])
                yy1.push(raw_data[i]['maleRate'])
                yy2.push(raw_data[i]['femaleRate'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy,
                type: 'scatter',
                mode: 'markers',
                name: 'Total Rate',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Male Rate',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Female Rate',
                marker: {color: 'red'},
            },
        ]
        // this.setState({data:clean_data})
        let Popcorrelation = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'Population VS Male and Female Suicide Rate',
                xaxis: {title:{text: 'Population'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({Popcorrelation});
    }


    updataGDPAgeCorrelation(year=this.state.year){
        console.log(year)
        var xx=[]
        let yy1 =[]
        let yy2 =[]
        let yy3 =[]
        let yy4 =[]
        let yy5 =[]
        let yy6 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if (raw_data[i]['year'] === year) {
                xx.push(raw_data[i]['GDP'])
                yy1.push(raw_data[i]['5-14'])
                yy2.push(raw_data[i]['15-24'])
                yy3.push(raw_data[i]['25-34'])
                yy4.push(raw_data[i]['35-54'])
                yy5.push(raw_data[i]['55-74'])
                yy6.push(raw_data[i]['75+'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 5-14',
                marker: {color: 'red'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 15-24',
                marker: {color: 'orange'},
            },
            {
                x: xx,
                y: yy3,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 25-34',
                marker: {color: 'purple'},
            },
            {
                x: xx,
                y: yy4,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 35-54',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy5,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 55-74',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy6,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 75+',
                marker: {color: 'black'},
            }

        ]
        // this.setState({data:clean_data})
        let GDPageCorr = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'GDP VS Age Group Suicide Rate',
                xaxis: {title:{text: 'GDP'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({GDPageCorr});
    }

    updataPopAgeCorrelation(year=this.state.year){
        console.log(year)
        var xx=[]
        let yy1 =[]
        let yy2 =[]
        let yy3 =[]
        let yy4 =[]
        let yy5 =[]
        let yy6 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if (raw_data[i]['year'] === year) {
                xx.push(raw_data[i]['population'])
                yy1.push(raw_data[i]['5-14'])
                yy2.push(raw_data[i]['15-24'])
                yy3.push(raw_data[i]['25-34'])
                yy4.push(raw_data[i]['35-54'])
                yy5.push(raw_data[i]['55-74'])
                yy6.push(raw_data[i]['75+'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 5-14',
                marker: {color: 'red'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 15-24',
                marker: {color: 'orange'},
            },
            {
                x: xx,
                y: yy3,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 25-34',
                marker: {color: 'purple'},
            },
            {
                x: xx,
                y: yy4,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 35-54',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy5,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 55-74',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy6,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 75+',
                marker: {color: 'black'},
            }

        ]

        // this.setState({data:clean_data})
        let PopAgeCorr = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'Population VS Age Group Suicide Rate',
                xaxis: {title:{text: 'Population'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({PopAgeCorr});
    }

    updataGenderPlot(selectedCountry=this.state.selectedCountry){
        var xx=[]
        let yy =[]
        let yy1 =[]
        let yy2 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['country'] === selectedCountry){
                xx.push(raw_data[i]['year'])
                yy.push(raw_data[i]['totalRate'])
                yy1.push(raw_data[i]['maleRate'])
                yy2.push(raw_data[i]['femaleRate'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy,
                type: 'scatter',
                mode: 'markers',
                name: 'Total Rate',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Male Rate',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Female Rate',
                marker: {color: 'red'},
            }
        ]
        // this.setState({data:clean_data})
        let genderPlot = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'Male and Female Suicide Rate',
                xaxis: {title:{text: 'Year'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({genderPlot});
    }
    updataAgeGroupPlot(selectedCountry=this.state.selectedCountry){
        var xx=[]
        let yy1 =[]
        let yy2 =[]
        let yy3 =[]
        let yy4 =[]
        let yy5 =[]
        let yy6 =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['country'] === selectedCountry){
                xx.push(raw_data[i]['year'])
                yy1.push(raw_data[i]['5-14'])
                yy2.push(raw_data[i]['15-24'])
                yy3.push(raw_data[i]['25-34'])
                yy4.push(raw_data[i]['35-54'])
                yy5.push(raw_data[i]['55-74'])
                yy6.push(raw_data[i]['75+'])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy1,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 5-14',
                marker: {color: 'red'},
            },
            {
                x: xx,
                y: yy2,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 15-24',
                marker: {color: 'orange'},
            },
            {
                x: xx,
                y: yy3,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 25-34',
                marker: {color: 'purple'},
            },
            {
                x: xx,
                y: yy4,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 35-54',
                marker: {color: 'green'},
            },
            {
                x: xx,
                y: yy5,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 55-74',
                marker: {color: 'blue'},
            },
            {
                x: xx,
                y: yy6,
                type: 'scatter',
                mode: 'markers',
                name: 'Age: 75+',
                marker: {color: 'black'},
            }

        ]
        // this.setState({data:clean_data})
        let ageGroupPlot = <Plot
            data={clean_data}
            layout={{width: 700, height: 300, title: 'Age Group Suicide Rate',
                xaxis: {title:{text: 'Year'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({ageGroupPlot});
    }

    updateGdpScatterPlot(selectedCountry=this.state.selectedCountry, selectedData=this.state.selectedData1) {
        var xx=[]
        let yy =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['country'] === selectedCountry){
                xx.push(raw_data[i]['year'])
                yy.push(raw_data[i][selectedData])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy,
                type: 'scatter',
                mode: 'markers',
                marker: {color: 'blue'},
            }
        ]
        // this.setState({data:clean_data})
        let gdpScatterPlot = <Plot
            data={clean_data}
            layout={{width: 800, height: 300, title: selectedData,
                xaxis: {title:{text: 'Year'}},yaxis: {title:{text: 'US Dollar ($)'}}}}
        />
        this.setState({gdpScatterPlot});
    }

    updateScatterPlot(selectedData, selectedCountry=this.state.selectedCountry){
        var xx=[]
        let yy =[]
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['country'] === selectedCountry){
                xx.push(raw_data[i]['year'])
                yy.push(raw_data[i][selectedData])
            }
        }
        clean_data=[
            {
                x: xx,
                y: yy,
                type: 'scatter',
                mode: 'markers',
                marker: {color: 'blue'},
            }
        ]
        // this.setState({data:clean_data})
        console.log('clean data', clean_data)
        let scatterPlot = <Plot
            data={clean_data}
            layout={{width: 800, height: 300, title: selectedData,
                xaxis: {title:{text: 'Year'}},yaxis: {title:{text: 'Suicide Rate per 100k population'}}}}
        />
        this.setState({scatterPlot});
        console.log('plot data', selectedData)
    }

    updateFirstMap=(selectedData)=>{
        this.setState({selectedData1: selectedData});
        this.updateGdpMap(this.state.year, selectedData);
        this.updateGdpScatterPlot(this.state.selectedCountry, selectedData)
    }

    updatePieChart=(year=this.state.year)=>{
        var xx=[]
        let yy =[]
        let yy2 = []
        var clean_data =[];
        var arrayLength = raw_data.length;

        // var limit = this.findLimit(raw_data['totalRate']);
        for (var i = 0; i < arrayLength; i++) {
            if(raw_data[i]['year'] === year){
                xx.push(raw_data[i]['country'])
                yy.push(raw_data[i]['totalRate'])
                yy2.push(raw_data[i]['GDP'])
            }
        }
        clean_data= [
            {
                type: 'bar',
                x: yy,
                y: xx,
                orientation: 'h',
                xaxis: 'x1',
                yaxis: 'y1',
                name: 'Suicide rate per 100k population',
                transforms: [{
                    type: 'sort',
                    target: 'x',
                    order: 'ascending'
                }
                // {
                //     type: 'filter',
                //     target: 'x',
                //     operation: '>',
                //     value: 1
                // }
                ]
            },
            {
                x: yy2,
                y: xx,
                xaxis: 'x2',
                yaxis: 'y1',
                orientation:'h',
                // sort: true,
                mode: 'markers',
                line: {
                    color: 'rgb(128,0,128)'
                },
                name: 'GDP ($)'

            }

        ];

        var layout ={
            title: 'Suicide Rate and GDP by Country (Year ' + year +')',
            // autosize: true,
            xaxis1: {
                range: [0, 50],
                domain: [0, 0.5],
                zeroline: false,
                showline: false,
                showticklabels: true,
                showgrid: true,
                title:{
                    text: 'Suicide Rate per 100k population'
                }
            },
            xaxis2: {
                range: [250, 75000],
                domain: [0.5, 1],
                zeroline: false,
                showline: false,
                showticklabels: true,
                showgrid: true,
                side: 'top',
                dtick: 25000,
                title:{
                    text: 'GDP Per Capita ($)'
                },
                automargin: true
            },
            legend: {
                x: 200.029,
                y: 1.238,
                font: {
                    size: 10
                }
            },
            width: 1000,
            height: 800,
            paper_bgcolor: 'rgb(248,248,255)',
            plot_bgcolor: 'rgb(248,248,255)',
            yaxis: {
                title:{text: 'Country'}, 
                dtick:1,
                automargin: true,
                tickfont:{
                    size: 8,
                }
            // colorbar:{
            //     tickfont :{
            //         size: 3
            //     }
            //     }
            },
            hovermode: 'closest'
        }
        console.log('clean data', clean_data)
        let  PieChart= <Plot data = {clean_data} layout = {layout}/>
        this.setState({PieChart});

    }
    render(){
        return (<div>
                <Row><h2 style={{textAlign: 'center'}}> {this.state.selectedData1} (Year {this.state.year})</h2></Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={18}>
                        {this.state.gdpMap}
                    </Col>
                    <Col span={4}>
                        <Selection updateData={this.updateFirstMap} />
                    </Col>
                </Row>
                <Row><h2 style={{textAlign: 'center'}}>Suicide Rate (Year {this.state.year})</h2></Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={18}>
                        {this.state.map}
                    </Col>

                    {/************* selections ************/}
                    <Col span={4} className="selection" >
                        <Selection2 updateData={this.updateData}/>
                    </Col>

                </Row>
                <Row>
                    <div style={{textAlign: 'center'}}>{this.state.year}</div>

                    <div style={{textAlign: 'center'}}>{this.state.selectedCountry}</div>
                    <PlaySlider year = {this.state.year} setYear={this.updateYear} />
                </Row>


                <Tabs defaultActiveKey= "1">
                    <TabPane tab="Correlation" key = "1">

                        <Row><h2 style={{textAlign: 'center'}}>Correlations by year ({this.state.year})</h2></Row>
                        <Row>
                            <Col span={12}>{this.state.GDPcorrelation}</Col>
                            <Col span={12}>{this.state.Popcorrelation}</Col>
                        </Row>
                        <Row>
                            <Col span={12}>{this.state.GDPageCorr}</Col>
                            <Col span={12}>{this.state.PopAgeCorr}</Col>
                        </Row>
                        <Row><CorrMap /></Row>
                    </TabPane>

                    <TabPane tab="Compare Suicide Rate With GDP/Population" key = "2">
                        <Row>
                            <Col span={12}>{this.state.scatterPlot}</Col>
                            <Col span={12}>{this.state.gdpScatterPlot}</Col>
                        </Row>
                    </TabPane>

                    <TabPane tab="Compare Suicide Rate among Male, Female and Age Groups" key = "3">
                        <Row>
                            <Col span={12}>{this.state.genderPlot}</Col>
                            <Col span={12}>{this.state.ageGroupPlot}</Col>
                        </Row>
                    </TabPane>

                    <TabPane tab="Bar Chart Comparsion" key = "4">
                        {/*<div>*/}
                            {/*{this.state.PieChart}*/}
                            {/*/!*<Col span={12}>{this.state.ageGroupPlot}</Col>*!/*/}
                        {/*</div>*/}
                        <div style={{display: 'flex',justifyContent:'center', alignItems:'center'}}>
                            <row> {this.state.PieChart} </row>
                        </div>
                    </TabPane>
                </Tabs>

                

            </div>
        );}

}